<template>
  <llp-page
    id="datatble-page"
    :menuOptions="menuOptions"
    :pageName="pageName"
    :userName="userName"
  >
    <template v-slot:body>
      <div class="rental-row">
        <div class="card m-4 m-lg-3">
          <div class="card-body">
            <div class="row p-0 align-items-center rental-payment">
              <div class="col mt-4 ms-sm-4">
                <h4>Unassign Group Charges</h4>
              </div>
              <div
                class="col-lg-2 col-md-3 col-sm-4 col-12 d-flex justify-content-end add-btn me-4"
              >
                <llp-button
                  :load-spinner="showaddUserSpinner"
                  classNames="btn-secondary text-nowrap new-btn d-none d-sm-block"
                  type="button"
                  @click:button="BackToGroupCharges()"
                >
                  Back To Group Charges
                </llp-button>
                <llp-button
                  :load-spinner="showaddUserSpinner"
                  classNames="btn-secondary text-nowrap new-btn d-block d-sm-none"
                  type="button"
                  @click:button="BackToGroupCharges()"
                >
                  Go Back
                </llp-button>
              </div>
            </div>
            <div class="row p-4">
              <div class="col mt-4 ms-sm-4">
                <h4>Unassign Group Charges</h4>
              </div>
              <llp-datatable
                ref="usersTable"
                :columns="columns"
                :data="assignCharges"
                :lazy="true"
                :paginator="true"
                :totalRecords="assignCharges.length"
                scrollable
                @onPageChange="onPageChange"
              >
                <!-- Header slot for Select All -->
                <template #selectHeader>
                  <div class="text-center">
                    <input
                      type="checkbox"
                      :checked="allSelected"
                      @change="toggleSelectAll($event)"
                    />
                  </div>
                </template>

                <!-- Row checkbox -->
                <template #actions="{ data }">
                  <div class="text-center">
                    <input
                      type="checkbox"
                      v-model="data.selected"
                      @change="onUserSelect(data)"
                    />
                  </div>
                </template>
              </llp-datatable>
            </div>
          </div>
        </div>
      </div>
    </template>
  </llp-page>
</template>

<script>
export default {
  setup() {},

  data() {
    return {
      assignCharges: "",
      columns: [
        { field: "s_no", className: "text-center", header: "S_no" },
        {
          field: "select_user",
          header: "Select User",
          className: "text-center",
          isCustomized: true,
          customizeName: "actions",
          headerSlot: "selectHeader",
        },

        { field: "username", className: "text-center", header: "User Name" },
        { field: "mobile", className: "text-center", header: "Mobile" },
      ],
    };
  },
  methods: {
    onUserSelect() {
      this.allSelected = this.assignCharges.every((user) => user.selected);
    },
    BackToGroupCharges() {
      this.$router.push("/charges");
    },
  },
};
</script>
